import { atom } from "recoil";

export const usersDataModal = atom({
  key: "usersDataModal",
  default: [],
});

export const LatestEpisodeData = atom({
  key: "LatestEpisodeData",
  default: [],
});

export const popupModal = atom({
  key: "popupModal",
  default: false,
});
